export var VERSION = '2.11.2';
//# sourceMappingURL=version.js.map